<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard>
        <CCardBody>
          <h3 v-if="isEditing">
            {{ $t('button.edit') }} {{ $t('expense_types.label') }}
          </h3>
          <h3 v-else>{{ $t('button.create') }} {{ $t('expense_types.label') }}</h3>
          <CInput :label="$t('fields.name')" type="text" :placeholder="$t('fields.expense_type_placeholder')" v-model="expenseType.name"></CInput>
          <CButton color="success" @click="saveData()">
              <template v-if="isEditing"><CIcon :content="$options.updateIcon" /> {{ $t('button.update') }}</template>
              <template v-else><CIcon :content="$options.addIcon" /> {{ $t('button.create') }}</template>
            </CButton>
          <CButton color="primary" @click="goBack"><CIcon :content="$options.backIcon" /> {{ $t('button.back') }}</CButton>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import formMixin from '../../mixins/form';
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilSync, cilPlus, cilArrowLeft } from '@coreui/icons';

export default {
  name: 'FormExpenseType',
  mixins: [formMixin, localeMixin],
  updateIcon: cilSync,
  addIcon: cilPlus,
  backIcon: cilArrowLeft,
  data() {
    return {
        expenseType: {
          name: '',
        }
    }
  },
  mounted() {
    if (this.isEditing) {
      this.getExpenseType();
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: "ExpenseTypes" });
    },
    showAlert(type, msg=null) {
      let title = '';
      let body = '';
      let status = '';
      let redirect = true;

      switch(type) {
        case 'add':
          title = i18n.t('expense_types.modal.created_label');
          body = i18n.t('expense_types.modal.created_body');
          status = 'success';
          break;
        case 'edit':
          title = i18n.t('expense_types.modal.updated_label');
          body = i18n.t('expense_types.modal.updated_body');
          status = 'success';
          break;
        case 'error':
          title = 'Error';
          body = msg;
          status = 'error';
          redirect = false;
          break;
      }

      this.$swal(
        title,
        body,
        status
      ).then(result => {
        if (redirect) {
          this.goBack();
        }
      });
    },
    saveData() {
        // const data = formData || this.prepareObjectData();
        const data = this.expenseType;
        this.$emit("saved", data);
        let url = `/api/expense-types`;
        let sendRequest = null;

        if (this.isEditing) {
            url = url + "/" + this.$route.params.id + '?token=' + localStorage.getItem("api_token");
            sendRequest = async() => {
                try {
                    const response = await axios.put(url, data);
                    if (response.data.status === "success") {
                        this.showAlert('edit');
                    }
                } catch (error) {
                    if(error.response.data.message == 'The given data was invalid.'){
                        let message = '';
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                message += error.response.data.errors[key][0] + '  ';
                            }
                        }
                        this.showAlert('error', message);
                    } else{
                        console.log(error);
                        this.$router.push({ path: '/login' }); 
                    }
                }
            };
        } else {
            url = url + '?token=' + localStorage.getItem("api_token");
            sendRequest = async() => {
                try {
                    const response = await axios.post(url, data);
                    if (response.data.status === "success") {
                        // this.expenseType = {
                        //   name: ''
                        // };
                        // for (const key in dataObject) {
                        //     dataObject[key] = "";
                        // }
                        this.showAlert('add');
                    }
                    // console.log(response.data);
                } catch (error) {
                    if(error.response.data.message == 'The given data was invalid.'){
                        let message = '';
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                message += error.response.data.errors[key][0] + '  ';
                            }
                        }
                        this.showAlert('error', message);
                    } else{
                        console.log(error);
                        this.$router.push({ path: '/login' }); 
                    }
                }
            };
        }
        sendRequest();
        return data;
    },
    getExpenseType() {
        const id = this.$route.params.id;
        axios.get('/api/expense-types/' + id + '?token=' + localStorage.getItem("api_token"))
        .then(response => {
            this.expenseType = response.data;
        }).catch(error => {
            console.log(error);
            this.$router.push({ path: '/login' });
        });
    }
  }
}

</script>
